import { SignUpState } from '@app/sign-up/models/sign-up.state';
import { createFeatureSelector } from '@ngrx/store';

export const selectSignUpState = createFeatureSelector<SignUpState>('signUp');
